import DiscardModal from './DiscardModal.container';

export default DiscardModal;
